import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthCard from '../components/AuthCard';
import SocialButtons from '../components/SocialButtons';

export default function Signup() {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    // TODO: kald API
  }

  return (
    <AuthCard backTo="/">
      <p className="login-subtitle">Opret din konto</p>

      <SocialButtons label="Opret med" />

      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="firstname">Fornavn</label>
            <input id="firstname" type="text" placeholder="Anders" autoComplete="given-name" required />
          </div>
          <div className="form-group">
            <label htmlFor="lastname">Efternavn</label>
            <input id="lastname" type="text" placeholder="Jensen" autoComplete="family-name" required />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" placeholder="din@email.dk" autoComplete="email" required />
        </div>

        <div className="form-group">
          <label htmlFor="password">Adgangskode</label>
          <div className="input-with-toggle">
            <input
              id="password"
              type={showPass ? 'text' : 'password'}
              placeholder="Minimum 8 tegn"
              autoComplete="new-password"
              required
              minLength={8}
            />
            <button
              type="button"
              className="toggle-pass"
              onClick={() => setShowPass((v) => !v)}
              aria-label={showPass ? 'Skjul adgangskode' : 'Vis adgangskode'}
            >
              {showPass ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>
        </div>

        <label className="terms-label">
          <input type="checkbox" required />
          <span>
            Jeg accepterer{' '}
            <button type="button" className="inline-link-btn" onClick={() => navigate('/terms')}>vilkårene</button>{' '}
            og{' '}
            <button type="button" className="inline-link-btn" onClick={() => navigate('/privacy')}>privatlivspolitikken</button>
          </span>
        </label>

        <button type="submit" className="login-btn">Opret konto</button>
      </form>

      <p className="login-footer">
        Har du allerede en konto?{' '}
        <button className="link-btn" onClick={() => navigate('/')}>Log ind</button>
      </p>
    </AuthCard>
  );
}
